import React from "react";
import { DistrictProgramsSection } from "./DistrictProgramsSection";
import { EducationSection } from "./EducationSection";
import { PanelContainer } from "./styles";
import type { MSHatData, DistrictProgramForHat } from "../../types";

interface BackRightPanelProps {
  hat: MSHatData;
  /** District programs matching this hat. Schools are pre-filtered server-side. */
  districtPrograms?: DistrictProgramForHat[];
  /** When true, skip the "See Your Matches" button + animation in the district programs section. */
  districtMatchesRevealed?: boolean;
  /** Fires once the calculating animation in the district programs section completes. */
  onDistrictMatchesRevealed?: () => void;
}

export const BackRightPanel = ({
  hat,
  districtPrograms,
  districtMatchesRevealed,
  onDistrictMatchesRevealed,
}: BackRightPanelProps) => {
  const hasDistrictPrograms = districtPrograms && districtPrograms.length > 0;

  return (
    <PanelContainer>
      {/* District programs (if any match), then education as fallback */}
      {hasDistrictPrograms && (
        <DistrictProgramsSection
          programs={districtPrograms!}
          revealed={districtMatchesRevealed}
          onRevealed={onDistrictMatchesRevealed}
        />
      )}
      {!hasDistrictPrograms && <EducationSection hat={hat} />}
    </PanelContainer>
  );
};
